import React from 'react';
import { render } from 'react-dom';
import { configure } from 'mobx';

import App from './components/App';
import setAppVersion from './version';

if (process.env.IS_DEVELOPMENT || process.env.IS_STAGING) {
  configure({
    enforceActions: 'always',
    isolateGlobalState: true,
  });
} else {
  configure({
    isolateGlobalState: true,
  });
}

const startApp = async () => {
  const rootElement = document.getElementById('partner-page');

  render(
    <App />,
    rootElement,
  );
};

setAppVersion();
startApp();
